export const DISMISS_APP = 'visa.src.dismiss-app';
export const HIDE_LAUNCH_LOADER = 'visa.src.hide-launch-loader';
export const PSP_TXN_SUCCESS = 'success';
export const ROUTE_USER_IN_DCF = 'visa.src.route-user-in-dcf';
export const SEND_ROUTING_INFO_TO_DCF = 'visa.src.send-routing-info-to-dcf';
export const SEND_GTM_USER_TYPE_IDENTIFICATION = 'src:sys-shell:gtm-user-type-identification';
export const SET_SYS_CONFIG = 'visa.src.set-sys-config';
export const SHOW_LAUNCH_LOADER = 'visa.src.show-launch-loader';
export const SYS_APP_LOADED = 'visa.app.loaded';
export const SYS_SRCI_LOADED = 'visa.srci.loaded';
export const SYS_APP_SHOW = 'visa.app.show';
export const SYS_BASE_CONFIG = 'visa.src.base-config';
export const SYS_CAMPAIGN_SUCCESS = 'visa.src.update-campaign-success';
export const SYS_CARD_BINS = 'visa.src.cardbins';
export const SYS_CHECKOUT = 'visa.src.checkout';
export const SYS_COMPLETE_IDENTITY_VALIDATION = 'visa.src.complete-identity-validation';
export const SYS_DCF_SUCCESS = 'src:dcf-app:update-intent-success';
export const SYS_DELETE_INTENT = 'visa:sys-shell:delete-intent';
export const SYS_DELETE_TOKENS = 'visa.src.delete-tokens';
export const SYS_FETCH_CONFIGS = 'visa.src.fetch-configs';
export const SYS_FETCHED_CONFIGS = 'visa.src.fetched-configs';
export const SYS_GENERATE_ACCESS_TOKEN = 'visa.src.access-token';
export const SYS_GET_SRC_PROFILE = 'visa.src.get-src-profile';
export const SYS_GOTO_DCF = 'src:sys-shell:go-to-dcf';
export const SYS_GOTO_INITIATOR = 'src:sys-shell:go-to-initator';
export const SYS_HANDLE_RESPONSE = 'visa.src.handle-response';
export const SYS_IDENTITY_LOOKUP = 'visa.src.identity-lookup';
export const SYS_INIT = 'visa.src.init';
export const SYS_INIT_DCF = 'visa.src.init-dcf';
export const SYS_INITIATE_IDENTITY_VALIDATION = 'visa.src.initiate-identity-validation';
export const SYS_IS_RECOGNIZED = 'visa.src.is-recognized';
export const SYS_MERCHANT_TRANSACTION_CANCEL = 'visa.src.merchant-transaction-cancel';
export const SYS_MERCHANT_TRANSACTION_SUCCESS = 'visa.src.merchant-transaction-success';
export const SYS_PUSH_EVENTS = 'visa.src.push-events';
export const SYS_PUSH_GTM_DATA = 'visa.src.push-gtm-data';
export const SYS_RESET_DCF_WHY = 'visa.src.reset-dcf-why';
export const SYS_RESET_USER_CONFIG = 'visa.src.reset-user-config';
export const SYS_SEND_USERNAME_LOOKUP_GTM_DATA = 'visa.src.username-lookup';
export const SYS_SESSION_RENEW = 'visa.src.session-app-renew';
export const SYS_SESSION_START = 'visa.src.session-start';
export const SYS_SESSION_TIMEOUT = 'visa.src.session-timeout';
export const SYS_SIGN_OUT = 'src:sys-shell:sign-out';
export const SYS_THM_PROFILING_START = 'visa.src.thm-profiling-start';
export const SYS_TNC_ACCEPTED = 'visa.src.tnc-accepted';
export const SYS_TXN_SUCCESS = 'visa.src.txn-success';
export const SYS_UNBIND_APP_INSTANCE = 'visa.src.unbind-app-instance';
export const SYS_UPDATE_VDCP_CONFIG = 'visa.src.update-vdcp-config';
export const SYS_UPDATE_VINIT_CONFIG = 'visa.src.update-vinit-config';
export const SYS_UPDATE_VISIT_ID = 'visa.src.update-visit-id';
// TODO: F19043 redact in Phase 2+3 PSP Performance Pass (VBA or THM on UNL)
export const SYS_SET_THM_PROFILE_ID = 'visa.thm.profile-id-set';
